import { error, clear } from '../alert/alert.actions';
import { AppDispatch } from '../../../models/redux/dispatch/app.dispatch';
import authFetch from '../../../utils/authFetch';
import { UPDATE_PROFILE, CLEAR_PROFILE } from '../../../constants/profile.constants';
import Profile from '../../../models/profile/Profile';
import { UpdateProfileAction, ClearProfileAction } from '../../../models/redux/actions/profile.action';

export function updateProfile(profile: Profile): UpdateProfileAction {
  return {
    type: UPDATE_PROFILE,
    profile,
  };
}

export function clearProfile(): ClearProfileAction {
  return {
    type: CLEAR_PROFILE,
  };
}

const getProfileAPIcall = (url: string) => {
  return (dispatch: AppDispatch) => {
    authFetch(dispatch, url, 'GET')
      .then((json) => {
        dispatch(updateProfile(json));
      })
      .catch((err) => {
        dispatch(error(err.message));
        setTimeout(() => {
          dispatch(clear());
        }, 6000);
      });
  };
};

const uploadProfilePictureAPIcall = (url: string, picture: FormData) => {
  return (dispatch: AppDispatch): void => {
    authFetch(dispatch, url, 'PUT', picture, '')
      .then((json) => {
        dispatch(updateProfile(json));
      })
      .catch((err: Error) => {
        dispatch(error(err.message));
        setTimeout(() => {
          dispatch(clear());
        }, 6000);
      });
  };
};

export { getProfileAPIcall, uploadProfilePictureAPIcall };
